(function ($) {
    $.nette.ext('redraw-snippet', {
        success(payload) {
            if (payload.redrawSnippet) {
                this.redrawSnippet(payload.redrawSnippet);
            }
        },
    }, {
        redrawSnippet(url) {
            $.nette.ajax({
                type: 'GET',
                url,
                disableSpinner: true,
            });
        },
    });
}(jQuery));
